import { render, staticRenderFns } from "./RecapScore.vue?vue&type=template&id=4ab9f0b0&scoped=true"
import script from "./RecapScore.vue?vue&type=script&lang=js"
export * from "./RecapScore.vue?vue&type=script&lang=js"
import style0 from "./RecapScore.vue?vue&type=style&index=0&id=4ab9f0b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab9f0b0",
  null
  
)

export default component.exports